import { useEffect, useState } from 'react';
import { useProfileStore } from '@/store/profile.store';

/**
 * Ensures profile store has rehydrated from localStorage before rendering.
 * Returns profile, readiness flag, and local mode flag.
 */
export function useProfileHydration() {
  const { profile, hasHydrated, isLocalMode } = useProfileStore();
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    if (hasHydrated) {
      setIsReady(true);
    }
  }, [hasHydrated]);

  return {
    isReady,
    profile,
    isLocalMode,
  };
}












